module.exports = __webpack_public_path__ + "static/media/add-friend-icon.728ee8d5.svg";